$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "organizer_product_group_link" && a === "list") {
    let product_group_link_delete_ajax_lock = false;

    $(document).on("click", ".product-group-link-delete-button", function () {
      let productId = $(this).attr("data-product-id");
      let productGroupId = $(this).attr("data-product-group-id");
      let locationId = $("body").attr("event_id");

      if (!product_group_link_delete_ajax_lock) {
        product_group_link_delete_ajax_lock = true;

        $.ajax({
          type: "POST",
          url: "/ajax/organizer_product_group_link/delete",
          data: {
            product_group_id: productGroupId,
            product_id: productId,
            location_id: locationId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#product-group-link-list-sortable").empty();
              $("#product-group-link-list-sortable").append(data.html);
              popupAlert();
            }

            if (data.product !== undefined && data.product !== null) {
              $("select[name='product_id']").prepend(
                $("<option>", {
                  value: productId,
                  text: data.product,
                }),
              );
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            product_group_link_delete_ajax_lock = false;
          })
          .always(function () {
            product_group_link_delete_ajax_lock = false;
          });
      }
    });
  }
});
